<template>
    <modal :show="show" showLarge>
        <div slot="modalHeader">
          <modal-header :closeModal="customClose">Project Footage Upload</modal-header>
        </div>
        <spinner-icon v-if="loading"/>
        <notifications :messages="notifications" v-if="showAssetNotification && notifications && notifications.length > 0"/>
      <label>Upload your Adobe After Effects footage here</label>
        <div>
          <div v-if="isAEP">
            <label class=""><small>Firstly, please select the exact name of your footage folder within your Adobe After Effects project:</small></label>
            <dropdown :options="footageOptions()" v-model="footageStructure" :current="'(Footage)'"/>
          </div>
          <br>
          <upload-file icon="upload" ctaText="Upload Footage Folder" @input="onUploadFootage" acceptedFileType="application/zip" :isDisabled="disabled"/>
          <br>
          <small>Upload the zipped contents of your footage folder. (Max file size 2GB. You can upload additional footage later)</small>
        </div>
        <div slot="modalFooter">
          <modal-footer cancelText="Close" :closeModal="customClose" hideConfirmText />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import UploadFile from '@/components/UploadFile/upload-file'
import SearchBox from '@/components/SearchBox/searchbox'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Notifications from '@/components/Notifications/notifications'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import AssetTable from '@/components/AssetTable/asset-table'

import {modalMixin} from '@/mixins/modalMixin'
import {assetMixin} from '@/mixins/assetMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_footage_library',
  mixins: [modalMixin, assetMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable,
    UploadFile,
    SearchBox,
    SpinnerIcon,
    Notifications,
    Dropdown,
    AssetTable
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String,
    fieldType: String,
    forceReloadFootageLibraryData: {type: Boolean, default: false},
    hasFootage: Boolean,
    footageStructure: {
      type: String,
      default: '(Footage)'
    },
    masters: Array
  },
  data: () => ({
    errors: {
      name: ''
    },
    search: '',
    showAssetNotification: false,
    dataLoaded: '',
    isEditing: false,
    disabled: false
  }),
  created () {},
  computed: {
    assetId () {
      return this.$route.params.id
    },
    isEditMode () {
      return this.confirmId
    },
    isAEP () {
      if (this.masters && this.masters[0]) {
        const ext = this.masters[0].name.split('.').pop()
        if (ext === 'aep') return true
        return false
      }
    }
    // filteredAssets () {
    //   return this.assets.filter(asset => {
    //     return asset.file.toLowerCase().includes(this.search.toLowerCase()) || asset.width.toLowerCase().includes(this.search.toLowerCase()) || asset.height.toLowerCase().includes(this.search.toLowerCase())
    //   })
    // }
  },
  watch: {
    footageStructure () {
      this.disabled = false
    },
    /**
     * When the parent component triggers a change for the prop {forceReloadAssetsLibraryData}, force the value for
     * dataLoaded to empty string to force the modal to reload the assets library due an update or change.
     */
    forceReloadAssetsLibraryData: function () {
      this.dataLoaded = ''
    }
  },
  methods: {
    customClose () {
      this.close()
    },
    callAssets () {
      if (this.show) {
        if ((typeof this.fieldType === 'undefined') && this.dataLoaded === 'all') {
          return
        }
        if (this.dataLoaded === 'video' && this.fieldType === 'video') {
          return
        }
        if (this.dataLoaded === 'image' && this.fieldType === 'image') {
          return
        }
        this.startLoading()
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Video asset box')
              this.finishLoading()
              this.dataLoaded = 'video'
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Image asset box')
              this.finishLoading()
              this.dataLoaded = 'image'
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading default asset box')
              this.finishLoading()
              this.dataLoaded = 'all'
            })
            break
        }
      }
    },
    selectImage (image) {
      this.$emit('selectImage', this.confirmId, this.field, image, this.fieldType)
      this.customClose()
    },
    onDeleteAsset (filename) {
      this.startLoading()
      const data = {
        id: this.assetId,
        fileName: filename
      }
      this.deleteAsset(data).then((response) => {
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'video'
              this.addNotification('success', response.reason)
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'image'
              this.addNotification('success', response.reason)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'all'
              this.addNotification('success', response.reason)
            })
            break
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    onUploadFootage (e) {
      this.close()
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      Object.keys(files).forEach((key) => {
        formData.append('file' + key, files[key])
        formData.append('footage', (this.footageStructure !== null) ? this.footageStructure : '(Footage)')
        formData.append('isEditing', this.isEditing)
      })
      const data = {
        id: this.assetId,
        file: formData
      }
      this.uploadFootage(data).then((response) => {
        const id = this.$route.params.id
        this.getCreativeUnits(id).then(() => {
          this.isEditing = false
          this.finishLoading()
          this.showAssetNotification = true
          this.dataLoaded = 'video'
          this.addNotification('success', response.status)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    footageOptions () {
      this.disabled = false
      const optionsArray = []
      let data = [
        'footage',
        '(Footage)',
        '_footage',
        'Footage'
      ]

      data.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },

    enableEdit () {
      this.isEditing = !this.isEditing
    }
  }
}
</script>

<style lang="scss">
  .asset {
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    border-radius: 3px;
    border: solid #e1e1e1 1px;

    .asset__img {
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 5px;
      height: 170px;
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      position: relative;
      overflow: hidden;
    }

    .asset__trash {
      position: absolute;
      top: 10px;
      right: 4px;
      background-color: #2c3247;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__video {
      position: absolute;
      top: 10px;
      left: 4px;
      background-color: #2c3247;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__info {
      padding: 5px;
      text-align: center;
    }

    .asset__info_table {
      display: table;
      width: 100%;
      height: 100%;

      span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/footage/modal-footage-library.vue